import { render, staticRenderFns } from "./FormNewWidget.vue?vue&type=template&id=4e6f7d77&scoped=true&"
import script from "./FormNewWidget.vue?vue&type=script&lang=js&"
export * from "./FormNewWidget.vue?vue&type=script&lang=js&"
import style0 from "./FormNewWidget.vue?vue&type=style&index=0&id=4e6f7d77&prod&scoped=true&lang=css&"
import style1 from "./FormNewWidget.vue?vue&type=style&index=1&id=4e6f7d77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f7d77",
  null
  
)

export default component.exports